import { render, staticRenderFns } from "./orderInternetDetail.vue?vue&type=template&id=0a94b2b2&scoped=true"
import script from "./orderInternetDetail.vue?vue&type=script&lang=js"
export * from "./orderInternetDetail.vue?vue&type=script&lang=js"
import style0 from "./orderInternetDetail.vue?vue&type=style&index=0&id=0a94b2b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a94b2b2",
  null
  
)

export default component.exports